import { lazy } from 'react';

const WebsiteAd = lazy(
  () => import('../../shared/dream-machine-ad/website-ad')
);
const VideoAd = lazy(() => import('../../shared/dream-machine-ad/video-ad'));
const LeadAd = lazy(() => import('../../shared/dream-machine-ad/lead-ad'));

export { WebsiteAd, VideoAd, LeadAd };
